// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__14vSM","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__xyd9u"};